import { DocumentItem, DocumentKind, ReceiptStatus, SignStatus } from '@/features/documents/types';

export const documents: DocumentItem[] = [
  // === TO_SIGN ===
  {
    id: 101,
    name: 'contrat-mission-janv-2025.pdf',
    type: 'Contrat',
    url: '/docs/contrat-mission-janv-2025.pdf',
    dateAdded: '2025-04-15',
    kind: DocumentKind.TO_SIGN,
    signTitle: 'Contrat de mission - Janvier 2025',
    signStatus: SignStatus.PENDING,
  },
  {
    id: 102,
    name: 'nda.pdf',
    type: 'Autre',
    url: '/docs/nda.pdf',
    dateAdded: '2025-04-10',
    kind: DocumentKind.TO_SIGN,
    signTitle: 'Accord de confidentialité',
    signStatus: SignStatus.PENDING,
  },

  // === RECEIPT ===
  {
    id: 201,
    name: 'Facture Uber avril 2025.pdf',
    type: 'Autre',
    url: '/docs/receipt-uber-avr-2025.pdf',
    dateAdded: '2025-04-15',
    kind: DocumentKind.RECEIPT,
    receiptStatus: ReceiptStatus.PENDING,
  },
  {
    id: 202,
    name: 'Justificatif arrêt maladie.png',
    type: 'Autre',
    url: '/docs/receipt-arret-maladie.png',
    dateAdded: '2025-04-12',
    kind: DocumentKind.RECEIPT,
    receiptStatus: ReceiptStatus.APPROVED,
  },

  // === LIBRARY ===
  {
    id: 1,
    name: 'Contrat de travail - 2025.pdf',
    type: 'Contrat',
    url: '/docs/contrat-2025.pdf',
    dateAdded: '2025-01-05',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 2,
    name: 'Fiche de paie - Janvier 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-janvier-2024.pdf',
    dateAdded: '2024-02-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 3,
    name: 'Fiche de paie - Février 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-fevrier-2024.pdf',
    dateAdded: '2024-03-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 4,
    name: 'Fiche de paie - Mars 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-mars-2024.pdf',
    dateAdded: '2024-04-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 5,
    name: 'Fiche de paie - Avril 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-avril-2024.pdf',
    dateAdded: '2024-05-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 6,
    name: 'Fiche de paie - Mai 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-mai-2024.pdf',
    dateAdded: '2024-06-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 7,
    name: 'Fiche de paie - Juin 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-juin-2024.pdf',
    dateAdded: '2024-07-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 8,
    name: 'Fiche de paie - Juillet 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-juillet-2024.pdf',
    dateAdded: '2024-08-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 9,
    name: 'Fiche de paie - Août 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-aout-2024.pdf',
    dateAdded: '2024-09-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 10,
    name: 'Fiche de paie - Septembre 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-septembre-2024.pdf',
    dateAdded: '2024-10-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 11,
    name: 'Fiche de paie - Octobre 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-octobre-2024.pdf',
    dateAdded: '2024-11-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 12,
    name: 'Fiche de paie - Novembre 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-novembre-2024.pdf',
    dateAdded: '2024-12-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 13,
    name: 'Fiche de paie - Décembre 2024.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-decembre-2024.pdf',
    dateAdded: '2025-01-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 14,
    name: 'Fiche de paie - Janvier 2025.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-janvier-2025.pdf',
    dateAdded: '2025-02-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 15,
    name: 'Fiche de paie - Février 2025.pdf',
    type: 'Fiche de paie',
    url: '/docs/paye-fevrier-2025.pdf',
    dateAdded: '2025-03-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 16,
    name: 'Fiche de paie - Mars 2025.pdf',
    type: 'Fiche de paie',
    url: '/docs/paie-mars-2025.pdf',
    dateAdded: '2025-04-01',
    kind: DocumentKind.LIBRARY,
  },
  {
    id: 17,
    name: 'Attestation employeur.pdf',
    type: 'Autre',
    url: '/docs/attestation.pdf',
    dateAdded: '2025-01-10',
    kind: DocumentKind.LIBRARY,
  },
];
